import {Observable} from 'rxjs';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TipoPetitum} from '../../../../../../../common/models/tipologiche/tipo-petitum';
import {PropertiesSettings} from '../../../../../../../core/configuration/properties-settings';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Petitum} from '../../../../../../../common/models/petitum';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { CreazionePraticaTipologicheService } from '../../../../services/creazione-pratica-tipologiche.service';

declare var $: any;

@Component({
  selector: 'app-petitum-form',
  templateUrl: './petitum-form.component.html',
  styleUrls: ['./petitum-form.component.css']
})
export class PetitumFormComponent implements OnInit, OnChanges {

  @Input()
  petitum: Petitum;
  @Output()
  onUpdatePetitum: EventEmitter<Petitum> = new EventEmitter<Petitum>();
  @Input()
  suggested: boolean;

  tipoPetitumOptions$: Observable<TipoPetitum[]>;

  formGroup: FormGroup;
  @Output()
  onValidForm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private tipologicheService: CreazionePraticaTipologicheService,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit() {
    this.initPetitum();
    this.initFormGroup();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initFormGroup();
  }

  initPetitum() {
    // console.log('[initPetitum]', '---');

    this.tipoPetitumOptions$ = this.tipologicheService.getTipiPetitum()
    .pipe(
      map(tipoPetitumArray => tipoPetitumArray.reverse())
    );
  }

  initFormGroup() {
    // console.log('[initFormGroup]', '---');

    this.formGroup = this.formBuilder.group({
      tipoPetitum: [this.petitum.tipoPetitum, Validators.required],
      importoPetitum: [this.petitum.importoPetitum],
      dataInizioCalcoloInteressi: [this.petitum.dataInizioCalcoloInteressi],
    });
    this.formGroup.get('tipoPetitum').valueChanges.pipe(distinctUntilChanged()).subscribe((it: TipoPetitum) => {
      // console.log('[changeFormGroup]', '[tipoPetitum]', it);

      this.petitum.tipoPetitum = it;

      if (it && it.id == PropertiesSettings.ID_TIPO_PETITUM_QUANTIFICABILE) {
        this.formGroup.get('importoPetitum').enable();
        this.formGroup.get('importoPetitum').setValidators([Validators.required , Validators.max(PropertiesSettings.MAX_VALUE_DECIMAL)]);
        this.formGroup.get('importoPetitum').updateValueAndValidity();
        if(this.petitum.importoPetitum){
          this.formGroup.get('importoPetitum').setValue(this.petitum.importoPetitum)
        }

        this.formGroup.get('dataInizioCalcoloInteressi').enable();
        this.formGroup.get('dataInizioCalcoloInteressi').setValidators(Validators.required);
        this.formGroup.get('dataInizioCalcoloInteressi').updateValueAndValidity();
      } else {
        this.formGroup.get('importoPetitum').reset()
        this.formGroup.get('importoPetitum').setValidators(null);
        this.formGroup.get('importoPetitum').updateValueAndValidity();
        this.formGroup.get('importoPetitum').disable();

        this.formGroup.get('dataInizioCalcoloInteressi').reset();
        this.formGroup.get('dataInizioCalcoloInteressi').setValidators(null);
        this.formGroup.get('dataInizioCalcoloInteressi').updateValueAndValidity();
        this.formGroup.get('dataInizioCalcoloInteressi').disable();
      }
    });
    this.formGroup.get('importoPetitum').valueChanges.pipe(distinctUntilChanged()).subscribe((it: string) => {
      // console.log('[changeFormGroup]', '[importoPetitum]', it);

      this.petitum.importoPetitum = it;
    });
    this.formGroup.get('dataInizioCalcoloInteressi').valueChanges.pipe(distinctUntilChanged()).subscribe((it: number) => {
      // console.log('[changeFormGroup]', '[dataInizioCalcoloInteressi]', it);

      this.petitum.dataInizioCalcoloInteressi = it;
    });
    this.formGroup.valueChanges.pipe(distinctUntilChanged()).subscribe(it => {
      this.onUpdatePetitum.emit(this.petitum);
      this.onValidForm.emit(this.formGroup.valid);
      /*if(this.formGroup.valid){
        this.onValidForm.emit(true);
      } else {
        this.onValidForm.emit(false);
      }*/
    });
    this.updateFormGroup();
  }

  updateFormGroup() {
    // console.log('[updateFormGroup]', '---', this.petitum);
    if(this.formGroup && this.petitum) {
      this.formGroup.get('tipoPetitum').setValue(this.petitum.tipoPetitum);
      this.formGroup.get('importoPetitum').setValue(this.petitum.importoPetitum);
      this.formGroup.get('dataInizioCalcoloInteressi').setValue(this.petitum.dataInizioCalcoloInteressi);
    }
  }

  changePetitum(petitum: Petitum){
    this.petitum = petitum;
    this.initFormGroup();
  }

  retrieveImporto(event: any){
    console.log(JSON.stringify(event))
  }
}
